export const ASESOR_SET_LOADING = 'ASESOR_SET_LOADING';
export const GET_ASESOR_EXITOSO = 'GET_ASESOR_EXITOSO';
export const ASESOR_GET_ERROR = 'ASESOR_GET_ERROR';
export const SET_CLICK_ASESOR = 'SET_CLICK_ASESOR';